import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LocationsOverview from './pages/LocationsOverview';
import LocationDashboard from './pages/LocationDashboard';

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Main overview page showing all locations */}
        <Route path="/" element={<LocationsOverview />} />
        
        {/* Location-specific routes */}
        <Route path="/:locationId" element={<LocationDashboard />} />
        <Route path="/:locationId/:sensorId" element={<LocationDashboard />} />
        
        {/* Redirect all other routes to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;